import { SidebarItem } from "./SidebarItem";
import { ChevronDown, Plus } from "lucide-react";

type SidebarEntry = {
	icon: "doc" | "link" | "video";
	title: string;
};

export function AppSidebar({
	activeItem,
	recentItems,
	starredItems,
}: {
	activeItem?: string;
	recentItems: SidebarEntry[];
	starredItems: SidebarEntry[];
}) {
	return (
		<div className="border-cv-bdr flex w-[220px] shrink-0 flex-col border-r">
			<div className="px-3 pt-3 pb-3">
				<button className="bg-cv-accent flex w-full items-center justify-center gap-1.5 rounded-md px-2.5 py-2 text-xs font-medium text-white">
					<Plus className="h-3 w-3" strokeWidth={2} />
					New
					<ChevronDown
						className="h-2.5 w-2.5 opacity-50"
						strokeWidth={2}
					/>
				</button>
			</div>
			<div className="px-4 pt-1 pb-1">
				<div className="text-cv-fg-muted text-[9px] font-semibold tracking-[0.12em] uppercase">
					Recent
				</div>
			</div>
			{recentItems.map((item) => (
				<SidebarItem
					key={item.title}
					icon={item.icon}
					title={item.title}
					active={item.title === activeItem}
				/>
			))}
			<div className="px-4 pt-4 pb-1">
				<div className="text-cv-fg-muted text-[9px] font-semibold tracking-[0.12em] uppercase">
					Starred
				</div>
			</div>
			{starredItems.map((item) => (
				<SidebarItem
					key={item.title}
					icon={item.icon}
					title={item.title}
				/>
			))}
			<div className="mt-auto px-4 pb-3">
				<span className="text-cv-fg-muted text-[10px]">Settings</span>
			</div>
		</div>
	);
}
